import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  readonly apiUrl = environment.apiUrl;

  loadConfig(): Observable<void> {
    return of(undefined);
  }
}
